export const NumberEnum = {
  Thausand: 1000,
  HundredThausand: 100000,
  Million: 1000000,
  Billion: 1000000000,
};
